import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import css from '../styles/pageheader';

class PageHeader extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,
    };

    render() {
        const { t } = this.props;

        return (
            <div className={ css.container }>
                <div className={ css.titleWrapper }>
                    <h2 className={ css.title }>{ t(this.props.title) }</h2>
                </div>
            </div>
        );
    }
}

export default translate('menu')(PageHeader);



/** WEBPACK FOOTER **
 ** /src/shared/components/PageHeader.js
 **/